import { pathOr } from 'ramda';
import { IOffer } from '../repositories/search-offers/v2/types';

export type TOffer = Pick<IOffer, 'newbuildingDynamicCalltracking' | 'newbuilding' | 'dealType'>;

export function getOfferExtra(offer: TOffer) {
  if (offer.dealType !== 'sale') {
    return undefined;
  }

  const siteBlockId = pathOr(null, ['newbuildingDynamicCalltracking', 'siteBlockId'], offer);
  const isFromDeveloper = pathOr(false, ['newbuilding', 'isFromDeveloper'], offer);
  const isFromLeadFactory = pathOr(false, ['newbuilding', 'isFromLeadFactory'], offer);

  return {
    cplDynamicCalltracking: siteBlockId ? 1 : 0,
    cplCalltracking: isFromDeveloper && !isFromLeadFactory ? 1 : 0,
  };
}
